import { Logger } from "../logger/logger";

export type RecoverableEvent = React.MouseEvent<HTMLAnchorElement> | React.FormEvent<HTMLFormElement>
export const syntheticDefault = (logger: Logger, event: RecoverableEvent) => {
    if (!event.defaultPrevented) return;

    const target = event.target;

    if (target instanceof HTMLAnchorElement) {
        if (target.href) {
            logger.count('DVWebNode-SyntheticDefault-Anchor', 1, false);
            window.location.href = target.href;
        } else {
            logger.fatal('Could not synthesise default behaviour as anchor tag has no href');
            return;
        }
    }

    if (target instanceof HTMLFormElement) {
        if (target.method === 'get') {
            const query: string[] = [];
            const iterator = new FormData(target).entries();
            while (true) {
                const { done, value } = iterator.next();
                if (done) break;
                const [ key, val ] = value;
                query.push(`${key}=${val}`);
            }
            logger.count('DVWebNode-SyntheticDefault-Form', 1, false);
            window.location.href = `${target.action}?${query.join('&')}`;
        } else {
            logger.warn('Will not retry post request from form as it is a write operation');
            return;
        }
    }

    logger.warn(`Cannot synthesise default event for ${typeof target}`);

}
